<template>
  <div class="content-wrapper" v-if="messages.length > 0">
    <!-- DANGER NOTIFICATION -->
    <div v-if="type === 'danger'" :class="`notification-box --${type} --container-width`">
      <div class="flex-align-center">
        <span :class="`icon --${type}`" aria-hidden="true"></span>
        <p class="text-base-semibold">Ein Fehler ist aufgetreten</p>
      </div>
      <div
        class="notification-container"
        v-for="message in messages"
        :key="message.__uuid"
        v-html="message.message"
      ></div>
      <button
        v-if="showDeleteButton"
        class="close-button"
        @click="clearMessages"
      ></button>
    </div>

    <!-- SUCCESS & WARNING NOTIFICATIONS -->
    <div v-else
         v-for="message in messages"
         :key="message.__uuid"
         :class="`notification-box --${type} --container-width`">

        <div class="flex-align-center">
          <span :class="`icon --${type}`" aria-hidden="true"></span>
          <p class="text-base-semibold" v-html="message.message"></p>
        </div>
        <button
          v-if="showDeleteButton"
          class="close-button"
          @click="clearMessages"
        ></button>
      </div>
    </div>
</template>

<script>
export default {
  name: 'MessageListComponent',
  data() {
    return {}
  },
  props: {
    messages: {
      type: Array
    },
    type: {
      type: String,
      default: 'danger'
    },
    clearMutation: {
      type: String,
      default: 'clearMessages'
    },
    showDeleteButton: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearMessages() {
      this.$store.commit(this.clearMutation, {})
    }
  }
}
</script>
